import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern, password_validation } from '../../../shared/constants';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-branch-form',
	templateUrl: './branch-form.component.html',
	styleUrl: './branch-form.component.css'
})
export class BranchFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	countries: any[] = [];
	company_list: any[] = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			company: [[], [Validators.required]],
			name: [null, [Validators.required]],
			address: [null, [Validators.required]],
			email: [null, [Validators.required, Validators.pattern(emailPattern)]],
			phone_no: ['', [Validators.pattern(mobilePattern)]],
			countryCode: [null],
			password: [null, [Validators.required, password_validation]],
			enable2fa: [false]
		});
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		this.getCountryCodes();
		this.getCompanyList();
		if (this.uId) {
			this.f.password.clearValidators();
			this.f.password.setValidators(null);
			this.f.password.updateValueAndValidity();
			this.getDetails();
		}
	}

	getCompanyList() {
		this.apiService.getCompanyList().subscribe({
			next: (data: any) => {
				this.company_list = data;
			}, error: (error) => {
				this.company_list = [];
			}
		});
	}

	getCountryCodes() {
		this.apiService.countryCodes().subscribe({
			next: (data: any) => {
				data.map((c: any) => {
					c.display = c.dial_code + "(" + c.name + ")"
					return c;
				})
				this.countries = data;
			}, error: () => {
				this.countries = [];
			}
		});
	}

	customSearchFn(term: string, item: any) {
		term = term.toLocaleLowerCase();
		if (item.dial_code != null && item.name != null) {
			return item.dial_code.toLocaleLowerCase().indexOf(term) > -1 || item.name.toLocaleLowerCase().indexOf(term) > -1;
		} else if (item.dial_code != null) {
			return item.dial_code.toLocaleLowerCase().indexOf(term) > -1;
		} else {
			return item.name.toLocaleLowerCase().indexOf(term) > -1
		}
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getBranchDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				if (data.company) {
					this.f.company.setValue(data.company.map((comp) => comp.id));
				} else {
					this.f.company.setValue([]);
				}
				this.f.name.setValue(data.name);
				this.f.email.setValue(data.email);
				this.f.address.setValue(data.address);
				this.f.phone_no.setValue(data.phone_no);
				this.f.countryCode.setValue(data.countryCode);
				this.f.enable2fa.setValue(data.enable2fa);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}

		let payload: any = {
			"address": this.f.address.value,
			"company": this.f.company.value,
			"name": this.f.name.value,
			"email": this.f.email.value,
			"phone_no": this.f.phone_no.value,
			"countryCode": this.f.countryCode.value,
			"enable2fa": this.f.enable2fa.value
		}
		if (this.uId) {
			payload["id"] = this.uId;
		} else {
			payload["password"] = this.f.password.value;
		}
		this.showLoader = true;
		this.apiService.createUpdateBranch(payload).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Branch saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Branch with name <strong>' + this.f.name.value + '</strong> already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreBranch(error.error.encrypt_id).subscribe({
								next: (data: any) => {
									this.toastr.success("Branch restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.created.emit(data);
									this.clearForm();
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						}
					})
				} else {
					let errorMsg = "Something went wrong.";
					/* if (error.status == 400) {
						errorMsg = "Branch name already exists";
					} */
					if (typeof error.error == "string") {
						errorMsg = error.error;
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true,
					});
				}
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
